<template>
   <div class="page-delivered">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">珠海倉庫</div>
         <div class="breadcrumb-item">已出庫</div>
      </div>

      <div class="card-block">
         <Form inline class="pg-form-inline">
            <FormItem>
               <Select style="width: 100%;" size="small" placeholder="提貨櫃點" v-model="form.arrive" :clearable="userInfo.user_role==1">
                  <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                          :key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
               </Select>
            </FormItem>
            <FormItem>
               <Select style="width: 100%;" size="small" placeholder="業務類型" v-model="form.goods_type">
                  <Option :value="0">無</Option>
                  <Option :value="item.id" v-for="(item, index) in packageType"
                          :key="item.id">
                     {{ item.describe }}
                  </Option>
               </Select>
            </FormItem>
            <FormItem>
               <Select style="width: 100%;" size="small" placeholder="第三方列表" v-model="form.order_parent" clearable>
                  <Option :value="item.id" v-for="(item, index) in samcityType"
                          :key="item.id">
                     {{ item.name }}
                  </Option>
               </Select>
            </FormItem>
            <FormItem>
               <Select size="small" placeholder="收件方式" v-model="form.arrive_type">
                  <Option value="1">門店</Option>
                  <Option value="2">智能櫃</Option>
               </Select>
            </FormItem>
            <FormItem>
               <Select style="width: 100%;" size="small" placeholder="操作人" v-model="form.admin_id">
                  <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                          :key="item.user_id">{{ item.username }} ({{ item.realname }})
                  </Option>
               </Select>
            </FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="珠海出庫-開始日期"
                           v-model="form.start_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false"
                           style='width: 100%;'></DatePicker>
            </FormItem>
            <FormItem>-</FormItem>
            <FormItem>
               <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="珠海出庫-結束日期"
                           v-model="form.end_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false"
                           style='width: 100%;'></DatePicker>
            </FormItem>
         </Form>

         <Form inline class="pg-form-inline form-input-wrap">
            <FormItem>
               <label class="input-label">快遞單號</label>
               <Input size="small" v-model="form.odd_numbers" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <label class="input-label">客戶名稱</label>
               <Input size="small" v-model="form.recipient_contacts" @keyup.enter.native="handleSearch()"
                      clearable></Input>
            </FormItem>
            <FormItem>
               <label class="input-label">客戶電話</label>
               <Input size="small" v-model="form.phone" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <label class="input-label">袋號</label>
               <Input size="small" v-model="form.sack_number" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleSearch">搜索</div>
                  <a target="_blank" class="pg-btn style2" @click="handleExport" style="margin-left: 15px;">導出excel</a>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <Spin fix class="pg-sub-loading" v-if="isSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
         </Spin>
         <Table size="small"
                border
                no-data-text="暫無數據"
                :columns="table.column"
                :data="table.data">
            <template slot-scope="{ row, index }" slot="arrive_type">
               <!-- 取貨方式 1:門店取貨; 2:智能櫃取貨-->
               <span v-if="row.arrive_type == 1">門店取貨</span>
               <span v-else-if="row.arrive_type == 2">智能櫃取貨</span>
            </template>

            <template slot-scope="{ row, index }" slot="status">
               <!-- 货物状态 0:待出库;1:已出库;2:配送中;3:代取件;4:已签收 -->
               <span>已出庫</span>
            </template>

            <template slot-scope="{ row, index }" slot="action">
               <div class="pg-btn-wrap">
                  <div class="pg-btn style3" @click="handleViewWuliu(index)">物流</div>
                  <div class="pg-btn style1" @click="handleEdit(index)" v-if="remarks == 1">修改</div>
                  <div class="pg-btn style2" @click="handleDelete(index)" v-if="remarks == 1">刪除</div>
               </div>
            </template>
         </Table>

         <div class="pg-pagger">
            <Row>
               <Col span="12" class="pagger-left">
                  <div class="pagger-total">總共{{ totalCount }}條記錄</div>
                  <br>
                  <div class="pagger-total">總重量為{{ totalWeight }}公斤</div>
               </Col>
               <Col span="12" class="pagger-right">
                  <!-- v-if="totalCount > curPageSize" -->
                  <div>
                     <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量"
                                @on-change="handlePageSizeChange">
                           <Option :value="10">10</Option>
                           <Option :value="20">20</Option>
                           <Option :value="30">30</Option>
                           <Option :value="40">40</Option>
                           <Option :value="50">50</Option>
                        </Select>
                     </div>

                     <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                     </div>

                     <Page size="small"
                           :current="pageIndex"
                           :page-size="curPageSize"
                           :total="totalCount"
                           @on-change="handlePageChange">
                     </Page>
                  </div>
               </Col>
            </Row>
         </div>

      </div>

   </div>
</template>

<script>
import Store from '../../../assets/js/store.js'

export default {
	data() {
		return {
			userInfo: localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {},
			pageIndex: 1,   //页码
			curPageSize: 10,    //一页数量
			totalCount: 1, //总条数
			totalWeight: 0, //總重量
			pageInput: '',  //输入的页码
			pickAdmin: [],
			pickAddress: [],    //提貨櫃點
			packageType: [],    //包裹類型
			samcityType: [],    //同城
			remarks: Store.fetch().type,
			isSubmiting: false,
			form: {
				arrive: '',    //提货柜点
				arrive_type: '',    //收件方式，1门店，2智能柜
				goods_type: 0, //包裹类型
				start_time: '',
				end_time: '',
				recipient_contacts: '', //客户名称
				phone: '',  //客户手机号
				odd_numbers: '',    //快递单号
				sack_number: '',    //袋号
				admin_id: '',
				order_parent: '',
			},
			exportLink: '',
			// isLoading: true,
			table: {
				column: [
					// {
					//     type: 'selection',
					//     minWidth: 60,
					//     align: 'center',
					// },
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						minWidth: 200
					},
					{
						title: '客戶名稱',
						key: 'recipient_contacts',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '客戶電話',
						key: 'customer_contacts',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '上架架號',
						key: 'shelves',
						align: 'center',
						sortable: true,
						minWidth: Store.fetch().store_id !== 0 ? 160 : 0
					},
					{
						title: '珠海入庫時間',
						key: 'in_time',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
					{
						title: '珠海出庫時間',
						key: 'out_time',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
					{
						title: '操作人(珠海倉庫)',
						key: 'actor',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '袋號',
						key: 'sack_number',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '出貨單號',
						key: 'odd_numbers',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '數量',
						key: 'count',
						align: 'center',
						sortable: true,
						minWidth: 80
					},
					{
						title: '重量',
						key: 'weight',
						align: 'center',
						sortable: true,
						minWidth: 80
					},
					{
						title: '泡重',
						key: 'volume_weight',
						align: 'center',
						sortable: true,
						minWidth: 80
					},
					{
						title: '集貨倉庫',
						key: 'depository',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '收件方式',
						key: 'arrive_type',
						align: 'center',
						slot: 'arrive_type',
						sortable: true,
						minWidth: 100
					},
					{
						title: '提貨櫃點',
						key: 'receivingName',
						align: 'center',
						sortable: true,
						minWidth: 120
					},
					{
						title: '貨物狀態',
						key: 'status',
						align: 'center',
						slot: 'status',
						sortable: true,
						minWidth: 100
					},
				
				],
				data: []
			}
		};
	},
	activated() {
		this.getSamcityList();
		this.getPickAddress();
		this.getPackageType();
		this.getPickAdmin();
	},
	created() {
		this.getSamcityList();
		this.getPickAddress();
		this.getPackageType();
		this.getPickAdmin();
	},
	mounted() {
	
	},
	methods: {
		handleViewWuliu(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/logisticsInfo?orderNo=' + tableData[index].odd_numbers});
		},
		handleEdit(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/deliveredEdit?id=' + tableData[index].id});
		},
		handleDelete(index) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定刪除嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					
					this.$Rq.requestAuth({
						url: this.$Api.deliverDelete + '/' + tableData[index].id,
						method: 'delete'
					}).then((res) => {
						this.isSubmiting = false;
						
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							
							if (tableData.length <= 1 && this.pageIndex > 1) {
								this.pageIndex -= 1;
							}
							
							this.getList();
							
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
					
				}
			});
		},
		getSamcityList() {
			const userInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
			this.$Rq.requestAuth({
				url: this.$Api.samecityUserList,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					if (userInfo.user_role == 1) {
						this.samcityType = res.data.data;
					}else {
						this.samcityType = res.data.data.filter(it => it.id == userInfo.parent_id)
					}
				}
			});
		},
		//提貨櫃點
		getPickAddress() {
			const userInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
			this.$Rq.requestAuth({
				url: this.$Api.pickAddress,
				method: 'get',
				data: {
					company_id: userInfo.parent_id || 0,
				}
			}).then((res) => {
				if (res.code == 0) {
					this.pickAddress = res.data.data;
					if (res.data.data.length) {
						if (userInfo.parent_id != 1) {
							this.form.arrive = res.data.data[0].ReceivingID;
						}else if (this.pickAddress.length == 1) {
							this.form.arrive = res.data.data[0].ReceivingID;
						}
					}
				}
			});
		},
		//操作人
		getPickAdmin() {
			const userInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
			this.$Rq.requestAuth({
				url: this.$Api.pickAdmin,
				method: 'post',
				data: {
					parent_id: userInfo.parent_id || 0,
				}
			}).then((res) => {
				if (res.code == 0) {
					this.pickAdmin = res.data.data;
				}
			});
		},
		//包裹類型
		getPackageType() {
			this.$Rq.requestAuth({
				url: this.$Api.packageType,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					this.packageType = res.data.data;
				}
			});
		},
		formatDate(datetime) {
			if (!datetime) return '';
			
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num;
		},
		getList() {
			let form = this.form;
			this.isSubmiting = true;
			this.table.data.length = 0
			// this.isLoading = true;
			this.$Rq.requestAuth({
				url: this.$Api.zhoutList,
				method: 'get',
				data: {
					status: 1,  //0待出库, 1已出库
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
					arrive: form.arrive,
					arrive_type: form.arrive_type,
					goods_type: form.goods_type,
					start_time: this.formatDate(form.start_time),
					end_time: this.formatDate(form.end_time),
					recipient_contacts: form.recipient_contacts,
					phone: form.phone,
					odd_numbers: form.odd_numbers,
					sack_number: form.sack_number,
					admin_id: form.admin_id,
					order_parent: form.order_parent,
				}
			}).then((res) => {
				this.isLoading = false;
				this.isSubmiting = false;
				
				if (res.code == 0) {
					let tempArr = [];
					let resData = res.data.data;
					
					for (let i = 0; i < resData.length; i++) {
						tempArr.push({
							id: resData[i].id,
							recipient_contacts: resData[i].recipient_contacts,
							customer_contacts: resData[i].recipient_phone,
							in_time: resData[i].in_time,
							out_time: resData[i].out_time,
							odd_numbers: resData[i].odd_numbers,
							sack_number: resData[i].sack_number,
							count: resData[i].count,
							weight: resData[i].weight,
							volume_weight: resData[i].volume_weight,
							depository: '珠海倉庫',
							arrive_type: resData[i].arrive_type,
							receivingName: resData[i].store ? resData[i].store.ReceivingName : '無',
							status: '已出库',
							actor: resData[i].admininfo == null ? '- - -' : resData[i].admininfo.username,
							shelves: resData[i].shelves
						});
					}
					
					this.totalCount = res.data.count;
					this.totalWeight = res.data.weightall;
					this.table.data = tempArr;
				}
			}).catch((err) => {
				// this.isLoading = false;
				this.isSubmiting = false;
			});
		},
		
		handleSearch() {
			this.pageIndex = 1;
			this.getList();
		},
		
		handleExport() {
			let token = localStorage.getItem('jyb_token');
			let form = this.form;
			let params = {
				// 'Authorization': token,
				status: 1,  //0待出库, 1已出库
				arrive: form.arrive,
				arrive_type: form.arrive_type,
				goods_type: form.goods_type,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time),
				recipient_contacts: form.recipient_contacts,
				phone: form.phone,
				odd_numbers: form.odd_numbers,
				sack_number: form.sack_number,
				admin_id: form.admin_id,
				order_parent: form.order_parent,
			};
			let formatParams = this.$Utils.formateObjToParamStr(params);
			if (form.start_time == '') {
				this.$Utils.showTipInfo("請選擇珠海出庫起始時間");
			} else if (form.end_time == '') {
				this.$Utils.showTipInfo("請選擇珠海出庫结束時間");
			} else {
				this.getList();
				window.open(`${this.$Api.deliverExport_old}?${formatParams}`, '_blank');
			}
		},
		
		//pager
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList();
		},
		
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList();
		},
		
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "Delivered.scss";
</style>
